import { NgModule } from '@angular/core';
import { Select2Component } from './components/select2/select2.component';

@NgModule({
  imports: [
  ],
  declarations: [
    Select2Component,
  ],
  exports: [
    Select2Component,
  ]
})

export class Select2Module { }
